import { useState } from "react";
import { useParams, Navigate, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import AFSLoansForm from "../components/forms/AFSLoansForm";
import SystemIssuesForm from "../components/forms/SystemIssuesForm";
import ProductionBugForm from "../components/forms/ProductionBugForm";
import SystemIncidentForm from "../components/forms/SystemIncidentForm";
import AccessRequestForm from "../components/forms/AccessRequestForm";
import GeneralIssuesForm from "../components/forms/GeneralIssuesForm";
import SuggestionForm from "../components/forms/SuggestionForm";
import QuestionForm from "../components/forms/QuestionForm";
import PlatformRequestForm from "../components/forms/PlatformRequestForm";
import { safeLocalStorageGet } from "../utils/safeJsonParse";
import { logout } from "../services/api";
import styles from "../styles/FormPage.module.css";

/**
 * Capitalizes the first letter of each word in a string.
 */
function formatName(name) {
  return name
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export default function StaffFormPage() {
  const { formId, subFormId } = useParams();
  const navigate = useNavigate();
  const [profile] = useState(() => safeLocalStorageGet("staff_profile", null));

  const rawName = profile
    ? `${profile.firstname} ${profile.lastname}`
    : "Tunde Usman";
  const displayName = formatName(rawName);

  // 1. Normalize formId
  const normalizedId = formId?.toLowerCase();

  // 2. Handle Access Request
  if (normalizedId === "access-request") {
    return <AccessRequestForm onBack={() => navigate("/staff/dashboard")} />;
  }

  // 3. Handle AFS & Loans
  if (normalizedId === "afs-loans") {
    return <AFSLoansForm onBack={() => navigate("/staff/dashboard")} />;
  }

  // 4. Handle System Issues
  if (normalizedId === "system-issues") {
    if (subFormId === "production-bug") {
      return (
        <ProductionBugForm
          onBack={() => navigate("/staff/request/system-issues")}
        />
      );
    }
    if (subFormId === "system-incident") {
      return (
        <SystemIncidentForm
          onBack={() => navigate("/staff/request/system-issues")}
        />
      );
    }
    return (
      <div className={styles.page}>
        <Navbar
          userName={displayName}
          onLogout={async () => {
            const token = localStorage.getItem("staff_token");
            const refreshToken = localStorage.getItem("staff_refresh_token");
            await logout(token, refreshToken);
          }}
        />
        <main className={styles.main}>
          <SystemIssuesForm />
        </main>
        <Footer />
      </div>
    );
  }

  // 5. Handle General Requests
  if (normalizedId === "general") {
    if (subFormId === "suggestion") {
      return (
        <SuggestionForm onBack={() => navigate("/staff/request/general")} />
      );
    }
    if (subFormId === "question") {
      return <QuestionForm onBack={() => navigate("/staff/request/general")} />;
    }
    return (
      <div className={styles.page}>
        <Navbar
          userName={displayName}
          onLogout={async () => {
            const token = localStorage.getItem("staff_token");
            const refreshToken = localStorage.getItem("staff_refresh_token");
            await logout(token, refreshToken);
          }}
        />
        <main className={styles.main}>
          <GeneralIssuesForm />
        </main>
        <Footer />
      </div>
    );
  }

  // 6. Handle Platform Request
  if (normalizedId === "platform-request") {
    return <PlatformRequestForm onBack={() => navigate("/staff/dashboard")} />;
  }

  // Fallback
  return <Navigate to="/staff/dashboard" replace />;
}
